import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  DefaultValueAccessor,
} from '@angular/forms';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { CommonService } from '../../../shared/providers/common.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { UserManagerService } from '../../../shared/providers/user-manager.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ReplaySubject, Observable, Subscription } from 'rxjs';
import { TagInputModule } from 'ngx-chips';

import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsService } from '../../../shared/providers/analytics.service';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { ISaveRequestBov } from '../../../shared/models/SaveRequestBov';
import { OnDestroy } from '@angular/core';

@Component({
  selector: 'app-my-portfolio-summary',
  templateUrl: './my-portfolio-summary.component.html',
  styleUrls: ['./my-portfolio-summary.component.css'],
})
export class MyPortfolioSummaryComponent implements OnInit, OnDestroy {
  currentMenu = '';
  constructor(
    private _commonService: CommonService,
    private router: Router,
    private PropertyListing: PropertyListingService,
    private Analytics: AnalyticsService,
    private propertyService: PropertyListingService,
    private _toastService: ToastService,
    public Validation: ValidationService,
    private modalService: BsModalService,
    public authentication: AuthenticationService,
    private _userManagerService: UserManagerService,
    private Loader: LoaderService
  ) {}
  modalRef: BsModalRef;
  BovRequest: ISaveRequestBov = {} as any;
  tenants: any[];
  user: any;
  selectedTenants: number[] = [];
  watchlistcount = [];
  tenantIds = [];
  portfoliosummary = [] as any;
  @Input() propertyListingAnalyze!: any;
  maxCount: number = 3;
  currentTenantCount = 3;
  modalRefBov: BsModalRef;
  requestedProperties = [] as any;
  @Input() UserGuid: string = '0000';
  @Input() PortfolioName: string = 'My Properties';
  Isdata: number = 0;
  subscriptions: Subscription[] = [];
  IsGlobalData: number = 0;
  ngOnInit() {
    this.UserGuid = this.UserGuid != '' ? this.UserGuid : '0000';
    this.user = this.authentication.user;
    this.getPortfolioSummary();
    this.Isdata = 0;
  }

  getPortfolioSummary() {
    this.subscriptions.push(
      this.propertyService
        .GetPortfolioSummary(this.user.Id, this.UserGuid)
        .subscribe((response) => {
          if (response != null) {
            this.portfoliosummary = response;
          }
        })
    );
  }

  openAddNewProperty() {
    this.router.navigate(['/portfolio-principal-property'], {
      queryParams: {
        prevroute: 'Market Snapshot',
        link: 'market-snapshot',
        UserGuid: this.UserGuid,
      },
    });
  }

  callAnalyzeParent() {
    this.propertyListingAnalyze.analyzeProperties();
  }

  RequestBov(
    propertyId: string = '',
    template: TemplateRef<any>,
    classes: any
  ) {
    if (
      propertyId != null &&
      propertyId != '' &&
      propertyId != undefined &&
      propertyId != '0'
    ) {
      var element = <HTMLInputElement>document.getElementById('btnExcel1');
      element.disabled = true;
      this.IsGlobalData = 1;
    } else {
      var element = <HTMLInputElement>document.getElementById('btnExcel');
      element.disabled = true;
      this.IsGlobalData = 2;
    }
    this.selectedRows = [];
    this.subscriptions.push(
      this.propertyService
        .getPrincipalProperties(0, this.user.Id, this.UserGuid)
        .subscribe((response) => {
          this.requestedProperties = response;
          if (
            this.requestedProperties != null &&
            this.requestedProperties.length > 0 &&
            this.requestedProperties != undefined
          ) {
            this.requestedProperties = this.requestedProperties.filter(
              (r) => r.DataentryPropertyStatusId != 6949
            );
          }
          if (propertyId == '') {
            this.requestedProperties.forEach((s) => {
              s.IsChecked = true;
              this.selectedRows.push(s);
            });
            this.selectAll = true;
          } else {
            if (
              this.requestedProperties.findIndex((x) => x.Guid == propertyId) >
              -1
            ) {
              this.requestedProperties.find(
                (x) => x.Guid == propertyId
              ).IsChecked = true;
              let prop = this.requestedProperties.find(
                (x) => x.Guid == propertyId
              );
              this.selectedRows.push(prop);
            }
            this.selectAll = false;
          }

          this.modalRefBov = this.modalService.show(template, {
            class: classes,
          });
        })
    );
  }
  selectedRows = [];
  onCheckboxChange(event, Id) {
    if (event) {
      let prop = this.requestedProperties.find((x) => x.Guid == Id);
      this.selectedRows.push(prop);
    } else {
      if (this.selectedRows.findIndex((x) => x.Guid == Id) > -1) {
        let index = this.selectedRows.findIndex((x) => x.Guid == Id);
        this.selectedRows.splice(index, 1);
      }
    }
  }
  SubmitBovRequest() {
    if (this.selectedRows != null && this.selectedRows.length > 0) {
      this.Loader.display(true);
      this.BovRequest.PropertyIds = this.selectedRows.map((o) => o.Guid);
      this.BovRequest.SellerId = this.user.Id;
      this.BovRequest.UserGuid = this.UserGuid;
      this.PropertyListing.SavePortfolioBov(this.BovRequest).subscribe(
        (res) => {
          if (res['Success']) {
            this.Isdata = 1;
            this._toastService.addToast({
              title: 'Success',
              msg: 'BOV Requested successfully',
              timeout: 5000,
              theme: 'bootstrap',
              position: 'bottom-right',
              type: 'success',
            });
            this.modalRefBov.hide();
            this.selectedRows = [];
            this.Loader.display(false);
            if (this.IsGlobalData == 1) {
              var element = <HTMLInputElement>(
                document.getElementById('btnExcel1')
              );
              element.disabled = false;
              this.IsGlobalData = 0;
            } else if (this.IsGlobalData == 2) {
              var element = <HTMLInputElement>(
                document.getElementById('btnExcel')
              );
              element.disabled = false;
              this.IsGlobalData = 0;
            }
          } else {
            this.Isdata = 0;
            this.Loader.display(false);
            if (this.IsGlobalData == 1) {
              var element = <HTMLInputElement>(
                document.getElementById('btnExcel1')
              );
              element.disabled = false;
              this.IsGlobalData = 0;
            } else if (this.IsGlobalData == 2) {
              var element = <HTMLInputElement>(
                document.getElementById('btnExcel')
              );
              element.disabled = false;
              this.IsGlobalData = 0;
            }
            this._toastService.addToast({
              title: 'Error Occurred',
              msg: res['ReturnMsg'],
              timeout: 5000,
              theme: 'bootstrap',
              position: 'bottom-right',
              type: 'error',
            });
          }
        }
      );
    } else {
      this._toastService.addToast({
        title: 'Error',
        msg: 'Please select at least one property',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }
  contactBroker() {
    this.PropertyListing.ContactBovBroker(
      this.user.Id,
      this.UserGuid
    ).subscribe((response) => {
      this._toastService.addToast({
        title: 'Success',
        msg: `Your request has been successfully submitted. The B+E team will get in touch with you shortly`,
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success',
      });
      this.modalRefBov.hide();
      this.selectedRows = [];
    });
  }

  selectAll = false;
  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    } else {
      this.selectOrUnSelectAll(false);
    }
  }

  selectOrUnSelectAll(trueOrfalse) {
    this.requestedProperties.forEach((item) => {
      item.IsChecked = trueOrfalse;
      if (trueOrfalse) {
        // if true then push all selected items into selectedRows collection
        if (this.selectedRows.findIndex((x) => x.Guid == item.Guid) < 0) {
          this.selectedRows.push(item);
        }
      } else {
        // if false then current item from the selected row collection
        this.selectedRows.splice(
          this.selectedRows.findIndex((x) => x.Guid == item.Guid),
          1
        );
      }
    });
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }
  modelClose() {
    if (this.IsGlobalData == 1) {
      var element = <HTMLInputElement>document.getElementById('btnExcel1');
      element.disabled = false;
      this.IsGlobalData = 0;
    } else if (this.IsGlobalData == 2) {
      var element = <HTMLInputElement>document.getElementById('btnExcel');
      element.disabled = false;
      this.IsGlobalData = 0;
    }
    this.Isdata = 0;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((item) => {
      item.unsubscribe();
    });
  }
}
